import swal from "sweetalert";
import axiosInstance from "../api";
import { setDashboardData } from "../../reusableSlice";







export const getDashboardData = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.get("admin/dashboard/", { params: data });
    console.log(response, "response dashboard");
    if (response?.data) {
      dispatch(setDashboardData(response?.data?.response));
    } else {
      dispatch(setDashboardData([]));
    }
  } catch (err) {
    dispatch(setDashboardData([]));
  }
};